// extracted by mini-css-extract-plugin
export default {"box":"Page_box__RBc5j","text":"Page_text__vJKk2","bgColor":"Page_bgColor__PPBA0"};